export const disablePlacementStatusOptions = [{
  activityTypeId: 1,
  activityStatusId: 1,
  activityStatus: 'Waiting for Clearance',
},    
{
  activityTypeId: 1,
  activityStatusId: 4,
  activityStatus: 'Declined by Traveler',
},
{
  activityTypeId: 1,
  activityStatusId: 5,
  activityStatus: 'Declined by Facility',
},
{
  activityTypeId: 1,
  activityStatusId: 7,
  activityStatus: 'Request Cancelled',
},
{
  activityTypeId: 3,
  activityStatusId: 4,
  activityStatus: 'Declined by Traveler',
},
{
  activityTypeId: 3,
  activityStatusId: 5,
  activityStatus: 'Declined by Facility',
},
{
  activityTypeId: 3,
  activityStatusId: 7,
  activityStatus: 'Request Cancelled',
},
{
  activityTypeId: 4,
  activityStatusId: 20,
  activityStatus: 'Canceled by Traveler',
},
{
  activityTypeId: 4,
  activityStatusId: 21,
  activityStatus: 'Canceled by Facility',
},
{
  activityTypeId: 4,
  activityStatusId: 22,
  activityStatus: 'Canceled by AMH',
},
{
  activityTypeId: 4,
  activityStatusId: 28,
  activityStatus: 'Canceled by Settlement',
}
];

export const disableRefreshContractPayroll = [
{
  activityTypeId: 1,
  activityStatusId: 4,
  activityStatus: 'Declined by Traveler',
},
{
  activityTypeId: 1,
  activityStatusId: 5,
  activityStatus: 'Declined by Facility',
},
{
  activityTypeId: 1,
  activityStatusId: 7,
  activityStatus: 'Request Cancelled',
},
{
  activityTypeId: 3,
  activityStatusId: 4,
  activityStatus: 'Declined by Traveler',
},
{
  activityTypeId: 3,
  activityStatusId: 5,
  activityStatus: 'Declined by Facility',
},
{
  activityTypeId: 3,
  activityStatusId: 7,
  activityStatus: 'Request Cancelled',
},
{
  activityTypeId: 4,
  activityStatusId: 20,
  activityStatus: 'Canceled By Traveler',
},
{
  activityTypeId: 4,
  activityStatusId: 21,
  activityStatus: 'Canceled By Facility',
},
{
  activityTypeId: 4,
  activityStatusId: 22,
  activityStatus: 'Canceled by AMH',
},
{
  activityTypeId: 4,
  activityStatusId: 28,
  activityStatus: 'Canceled by Settlement',
}
];